import { config } from '../config'

export const getBaseUrl = (prefix = ''): string => {
  const isDev = process.env.NODE_ENV === 'development'
  const isStage = config.env === 'stage'
  const subdomain = `studio${isStage || isDev ? '-stage' : ''}`

  return `https://${subdomain}.moises.ai/${prefix}`
}
